import api from 'Application/api/api';

const selectIntroductionPoint = (
    projectId,
    introductionId,
    point,
    cancelToken = null,
) =>
    api.post(
        `project-manager/projects/${projectId}/introductions/${introductionId}/select-point`,
        {
            point,
        },
        { cancelToken },
    );

export default selectIntroductionPoint;
